<template>
    <div class="componentsCtn_1">
        <div class="top">
            我的作业
            <div class="topRadioCtn">
                <v-radio-group
                        v-model="selectedRadio"
                        @change="selectChange"
                        row
                >
                    <v-radio
                            label="全部"
                            color="#c49760"
                            value=""
                    ></v-radio>
                    <v-radio
                            label="已完成"
                            color="#c49760"
                            value="1"
                    ></v-radio>
                    <v-radio
                            label="未完成"
                            color="#c49760"
                            value="0"
                    ></v-radio>
                </v-radio-group>
            </div>
        </div>
        <div class="signUp_content">
            <div v-for="item in dataList" :key="item.id" class="signUp_item_banner">
                <table>
                    <tr style="font-size: 14px;color: #979797;font-weight: 400;height: 32px;">
                        <td width="320px" style="vertical-align: text-top">课程名称</td>
                        <td width="265px" style="vertical-align: text-top">最近学习时间</td>
                        <td width="235px" style="vertical-align: text-top">作业状态</td>
                        <td width="150px" style="vertical-align: text-top">操作</td>
                    </tr>
                    <tr style="height: 50px;font-size: 16px;" >
                        <td  style="vertical-align: text-top;width:425px;word-break: break-all;word-wrap:break-word;color: #3A3A3A;font-size: 16px;padding-right: 15px;">
                            {{item.name}}
                        </td>
                        <td style="vertical-align: text-top">
                            {{item.createTime}}
                        </td>
                        <td style="vertical-align: text-top">
                            <!--未完成-->
                            <span v-if="item.status=='0'">
                                未完成
                            </span>
                            <!--已完成-->
                            <span v-if="item.status=='1'">
                                <span v-if="item.status=='1'">
                                    <div style="display: inline-block;width: 64px;height: 24px;background: #CCCCCC;border-radius: 2px;text-align: center;color: #ffffff;">
                                         已完成
                                    </div>
                                </span>
                            </span>
                        </td>
                        <td style="vertical-align: text-top;color: #C49760;cursor:pointer">
                          <span   @click="$router.push({path:'/homeWork',query:{'homeworkId':item.id,'courseId':item.courseId}})"
                                  v-if="item.status=='0'">
                                完成作业
                          </span>
                            <span   @click="$router.push({path:'/homeWork',query:{'homeworkId':item.id,'courseId':item.courseId}})"
                                    v-if="item.status=='1'">
                                作业回访
                          </span>
                        </td>
                    </tr>
                </table>

            </div>
            <div v-if="haNoClass" style="width: 100%;height: 16px;line-height: 16px;text-align: center;color: #3A3A3A;margin-top: 160px;">
                暂无作业记录
            </div>
        </div>
    </div>

    
</template>

<script>
    export default {
        name: "task",
        data(){
            return{
                selectedRadio:'',
                dataList:[],
                haNoClass:false,

            }
        },
        methods:{
            getKey() {
                return localStorage.getItem("token");
            },
            selectChange:function(){
                this.getLessionData();
            },
            getLessionData:function () {
                let that=this
                let param = new FormData();
                console.log(this.selectedRadio,"select");
                param.append('status', this.selectedRadio);
                this.axios
                    .get("/learn_back/course/homework/getAllHomeworks", {
                        params:{
                            status:this.selectedRadio
                        }
                    },{
                        headers: {
                            Authorization: "Bearer " + this.getKey(),
                        }
                    }).then((response) => {
                    console.log('用户作业')
                    console.log(response)
                    if(response.data.code == 200){
                        that.dataList=response.data.data
                        console.log(that.dataList)
                        console.log(that.dataList.length)
                        if(that.dataList.length<1){
                            that.haNoClass=true;
                        }
                        else {
                            that.haNoClass=false;
                        }
                    }
                })
            },


        },
        mounted(){
            // this.getSignUpData();
            this.getLessionData();

        }
    }
</script>

<style scoped>
    .signUp_item_banner{
        width: 1032px;
        height: 122px;
        background: #F7F7F7;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-top:31px;
        padding-left:39px;
    }
    .signUp_content{
        width: 100%;
        height: 576px;
        padding-left: 35px;
        overflow-y: auto;
    }
    /*滚动条样式*/
    .signUp_content::-webkit-scrollbar {
        width: 4px;
    }
    .signUp_content::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    .signUp_content::-webkit-scrollbar-track {
    }
    .topRadioCtn{
        position:absolute;
        right:0px;
        top:10px;
        width: auto;
        height: 84px;
        line-height: 84px;
        padding-right: 35px;
    }
    .top{
        position:relative;
        height: 84px;
        line-height: 84px;
        padding-left: 35px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
    }
    .componentsCtn_1{
        width: 100%;
        height: 660px;
        background: #FFFFFF;
        border-radius: 16px;
    }

</style>